import {configureStore} from "@reduxjs/toolkit";

import rootReducer from "./RootReducer";

// Configure the Redux store
const store = configureStore({
	reducer: rootReducer,
	// Note: It's often useful to enable Redux DevTools for development.
	// You can conditionally enable it based on the environment if needed.
	// devTools: false,
	devTools: process.env.NODE_ENV !== "production",
	middleware: (getDefaultMiddleware) => {
		const middleware = getDefaultMiddleware();

		if (process.env.NODE_ENV === "development") {
			// Required lazily so redux-logger is dead-code-eliminated from production bundles.
			// eslint-disable-next-line @typescript-eslint/no-var-requires
			const {createLogger} = require("redux-logger");
			middleware.push(createLogger({collapsed: true, duration: true}) as any);
		}

		return middleware;
	},
});

// Types related to the store
type StoreType = typeof store;
type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export default store;

export type {StoreType, RootState, AppDispatch};
